import HttpClient from "@/common/boot/HttpClient"

const listarAutenticacoes = async({ commit }, payload) => {

    commit('CARREGANDO', true);

    await HttpClient.get('/app/acl-autenticacoes', payload).then(response => {
            commit('LISTAR_DADOS', response.data.data);
            return response;
        })
        .finally(() => {
            commit('CARREGANDO', false);
        });
}

const excluirAutenticacoes = async({ dispatch }, payload) => {
    let qtdRows = payload.length;
    for (let i = 0; i < qtdRows; ++i) {
        await excluir(payload[i]);
    }

    dispatch('listarAutenticacoes');
}

const excluir = async(linha) => {
    const resp = await HttpClient.delete(`/app/acl-autenticacoes/${linha.id}`).then(response => { return response; });
    return resp;
}

const salvarAutenticacao = async({ commit }, payload) => {

    commit('CARREGANDO', true);

    return await HttpClient.post('/app/acl-autenticacoes', payload).then(response => {
            commit('INSERIR_AUTENTICACAO', response.data.data);
            return response;
        })
        .finally(() => {
            commit('CARREGANDO', false);
        });
}

const recuperarAutenticacao = ({ commit, state }, payload) => {
    const autenticacao = state.items.filter(autenticacao => autenticacao.id === payload.id);
    if (autenticacao.length) {
        commit('INSERIR_AUTENTICACAO_SELECIONADO', ...autenticacao);
        return true;
    }

    return false;
}

const atualizarAutenticacao = async({ commit }, payload) => {
    commit('CARREGANDO', true);
    return await HttpClient.put(`/app/acl-autenticacoes/${payload.id}`, payload).then(response => {
            commit('ATUALIZAR_AUTENTICACAO', response.data.data);
            return response;
        })
        .finally(() => {
            commit('CARREGANDO', false);
        })
}

export {
    listarAutenticacoes,
    excluirAutenticacoes,
    salvarAutenticacao,
    recuperarAutenticacao,
    atualizarAutenticacao
}